import CustomIcon from "../../../components/CustomIcon";
import React from "react";

export const LocationItem = ({label = "Province One", selected = false, onSelected}) => {
  return (
    <div onClick={onSelected}
         className={`p-1 border m-2 flex items-center justify-between cursor-pointer ${selected && "bg-secondary-100"}`}>
      <div>{label}</div>
      {selected && <CustomIcon icon="chevron_right" size="xl"/>}
    </div>
  )
}

export const LocationItemLoader = () => {
  return (
    <div
      className="p-1 border m-2 flex items-center justify-between cursor-pointer">
      <div className="h-6 w-full bg-secondary-100"/>
      <CustomIcon icon="chevron_right" size="xl"/>
    </div>
  )
}